import { render } from "./DismissButton.vue?vue&type=template&id=7dcc083d"
import script from "./DismissButton.vue?vue&type=script&lang=js"
export * from "./DismissButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__